import { Module } from 'vuex';

import { RecentLessonInfoState, RootState } from 'frontend/types';

export interface RecommendedLessonsInfoState {
  recommended: RecentLessonInfoState[];
}

const recommendedLessonsInfo: Module<RecommendedLessonsInfoState, RootState> = {
  namespaced: true,
  state: {
    recommended: [],
  } as RecommendedLessonsInfoState,
  getters: {
    recommendedLessonsList: (state: RecommendedLessonsInfoState): RecentLessonInfoState[] => {
      return state.recommended;
    },
  },
  mutations: {
    setValue(state: RecommendedLessonsInfoState, value: RecentLessonInfoState[]): void {
      state.recommended = value;
    },
  },
  actions: {},
};

export default recommendedLessonsInfo;
